var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultRewardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 241,
    viewBox: "0 0 180 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 241,
    fill: "url(#paint0_linear_124_22562)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_124_22562)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.25 110.875L119 102.25L104.25 93.6245V110.875Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.75 128.125L89.5001 136.75L74.75 145.375V128.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5001 119.5L74.75 128.125L89.5001 136.75V119.5Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.75 145.376L89.5001 154V136.75L74.75 145.376Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 136.75V136.75L74.7495 145.375V128.125L60 136.75Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.25 128.125L119 136.75V119.5L104.25 128.125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5 102.25L104.25 110.875L89.5 119.5V102.25Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 119.5V119.501L74.7495 128.126V110.875L60 119.5Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5 154L104.25 145.376L89.5 136.75V154Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.25 145.375L119 136.75L104.25 128.125V145.375Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5001 85L74.75 93.6244L89.5001 102.25V85Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.25 110.875L89.5 119.5L104.25 128.125V110.875Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.25 128.125L89.5 136.75L104.25 145.375V128.125Z",
    fill: "#B2D530"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_124_22562",
    x: 60,
    y: 85,
    width: 59.3,
    height: 69.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.309804 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_124_22562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_124_22562",
    x1: 90,
    y1: -0.0000105134,
    x2: 231.904,
    y2: 72.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546470"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultRewardImage);
export default __webpack_public_path__ + "static/media/default-reward-image.0f0e53b0240637877924cfcf4d656f35.svg";
export { ForwardRef as ReactComponent };